import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, fmtDate } from "@/lib/api";
import { Loader, Empty } from "@/components/common";
import { RichHtml } from "@/components/RichText";

export default function LegalPage({ slug: slugProp }) {
  const params = useParams();
  const slug = slugProp || params.slug;
  const [doc, setDoc] = useState(undefined);
  useEffect(() => {
    setDoc(undefined);
    api.get(`/legal/${slug}`).then((r) => setDoc(r.data)).catch(() => setDoc(null));
  }, [slug]);
  if (doc === undefined) return <Loader />;
  return (
    <div className="w-container py-10 max-w-3xl" data-testid={`legal-page-${slug}`}>
      {doc === null ? (
        <Empty>Dieses Dokument ist noch nicht veröffentlicht.</Empty>
      ) : (
        <article>
          <h1 className="text-3xl md:text-4xl font-extrabold mb-2" data-testid="legal-title">{doc.title}</h1>
          {doc.updated_at && <p className="w-muted text-sm mb-6">Stand: {fmtDate(doc.updated_at.slice(0, 10))}</p>}
          <div data-testid="legal-content"><RichHtml html={doc.body} className="leading-relaxed" /></div>
        </article>
      )}
    </div>
  );
}
